import { useCallback } from "react";

const usePasswordValidation = (passwordFieldValue: string) => {
    const validatePassword = useCallback((val: string) => {
        if (!val){
            // Handled by is required validator
            return null;
        }

        const isValid = /^(?=.{10,})(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/.test(val);
        return isValid 
            ? null
            : "Password must be at least 10 characters and include uppercase, lowercase, numeric, and special characters.";
    }, [])

    const validateConfirmPassword = useCallback((confirmVal: string) => {
        if (!passwordFieldValue || !confirmVal){
            // Handled by is required validator
            return null;
        }

        const isMatch = passwordFieldValue === confirmVal;
        if (isMatch) {
            return null;
        }

        return 'The passwords do not match.';
    }, [passwordFieldValue])

    return {
        validatePassword,
        validateConfirmPassword,
    }
}


export default usePasswordValidation;